import { useState } from "react";
// --------------------- Services ----------------------------
import { buscarEtiquetaPessoaService } from "../../../services/buscarEtiquetaPessoaService";
import { cadastrarEtiquetaPessoaService } from "../../../services/cadastrarEtiquetaPessoaService";

// ---------------------  ----------------------------

export const useMarcarEtiqueta = () => {
  const [success, setSuccess] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [warning, setWarning] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);
  const resetWarning = () => setWarning(null);

  const marcarEtiqueta = async (
    dados: { pessoaId: number | null }[],
    etiquetaId: number | undefined
  ) => {
    setIsLoading(true);

    // 🟡 Nenhuma pessoa selecionada
    if (dados.length === 0) {
      setWarning("Nenhuma pessoa foi selecionada para marcar etiqueta.");
      setIsLoading(false);
      return;
    }

    // 🟡 Nenhuma etiqueta selecionada
    if (!etiquetaId) {
      setWarning("Nenhuma etiqueta foi selecionada.");
      setIsLoading(false);
      return;
    }

    try {
      // Buscar etiquetas-pessoas já cadastradas
      const registrosExistentes = await buscarEtiquetaPessoaService();

      //  Filtrar apenas quem ainda não tem essa etiqueta
      const dadosFiltrados = dados.filter((novo) => {
        return !registrosExistentes.some((registrado: any) => {
          const pessoaIdExistente = registrado.Pessoa?.id;
          const etiquetaIdExistente = registrado.Etiqueta?.id;

          return (
            pessoaIdExistente === novo.pessoaId &&
            etiquetaIdExistente === etiquetaId
          );
        });
      });

      // Nenhum novo registro para cadastrar
      if (dadosFiltrados.length === 0) {
        if (dados.length === 1) {
          setWarning(
            "A pessoa selecionada já está cadastrada com essa etiqueta."
          );
        } else {
          setWarning(
            "Todas as pessoas selecionadas já estão cadastradas com essa etiqueta."
          );
        }
        return;
      }

      // 🟢 Cadastrar apenas novos vínculos pessoa-etiqueta
      for (const { pessoaId } of dadosFiltrados) {
        const data = { pessoaId, etiquetaId };
        const cadastrar = await cadastrarEtiquetaPessoaService(data);

        if (!cadastrar) {
          throw new Error(`Erro ao marcar etiqueta para pessoaId: ${pessoaId}`);
        }
      }

      setSuccess("Etiqueta marcada com sucesso!");
    } catch (error) {
      console.error(error);
      setError("Erro ao marcar etiqueta. Tente novamente!");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    marcarEtiqueta,
    error,
    success,
    warning,
    resetError,
    resetSuccess,
    resetWarning,
    isLoading,
  };
};
